import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index'; // Corrected import path
import Vue3Select from 'vue3-select';

// createApp(App).use(router).mount('#app');
const app = createApp(App);
app.use(router);
app.component('v-select', Vue3Select);
app.mount('#app');